import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { CarregandoService } from "../../../services/carregando.service";
import { ArquivoService } from "../../../services/arquivo.service";
import { NotificacaoService } from "../../../services/notificacao.service";
import { TipoArquivo } from "../../../models/enum";
import { UtilitarioService } from "../../../services/utilitario.service";
import { AnexoModel } from "../../../dominio/anexo-model";
import { TipoAnexoService } from "../../services/tipo-anexo.service";
import { TipoSituacaoCadastral } from "src/app/dominio/enums";
import { QueryFilterService } from "../../services/query-filter-service";
import swal from "sweetalert2";
import { TipoAnexoModel } from "../../../dominio/tipo-anexo-model";

@Component({
  selector: "app-anexo-uploader-v2",
  templateUrl: "./anexo-uploader-v2.component.html",
  styleUrls: ["./anexo-uploader-v2.component.scss"],
})
export class AnexoUploaderV2Component implements OnInit, OnChanges {
  @Input() somenteLeitura: boolean;
  @Input() multiplos: boolean = true;
  @Input() anexos: AnexoModel[] = [];

  @Output() aoCriar = new EventEmitter<AnexoModel[]>();
  @Output() aoAtualizar = new EventEmitter<AnexoModel>();
  @Output() aoExcluir = new EventEmitter<AnexoModel>();

  anexosInterno: AnexoModel[] = [];
  tiposAnexos: TipoAnexoModel[] = [];
  usaClassificacao: boolean = false;

  constructor(
    private carregandoService: CarregandoService,
    private arquivoService: ArquivoService,
    private notificacaoService: NotificacaoService,
    private utilitarioService: UtilitarioService,
    private queryFilterService: QueryFilterService,
    private tipoAnexoServiceV2: TipoAnexoService
  ) {}

  ngOnInit() {
    this.buscaTiposAnexos();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.anexos && changes.anexos.currentValue !== changes.anexos.previousValue) {
      this.configurarAnexos();
    }
  }

  configurarAnexos() {
    this.anexosInterno = this.anexos.map(p => {
      const obj = Object.assign({}, p);

      if (!obj.tipoAnexo) {
        obj.tipoAnexo = {
          id: 0,
          nome: 'Classificar',
        }
      }

      return obj;
    });
  }

  buscaTiposAnexos() {
    this.tiposAnexos = [];
    this.carregandoService.mostra("buscaTiposAnexos");

    const queryFilter = this.queryFilterService.getQueryBuilder()
      .addCondition("situacao", "=", TipoSituacaoCadastral.Ativo)
      .build();

    this.tipoAnexoServiceV2.buscarTodos(queryFilter).subscribe(
      (tiposAnexos) => {
        this.tiposAnexos = tiposAnexos.results;
        this.usaClassificacao = this.tiposAnexos.length > 0;
      },
      (erro) => {
        this.carregandoService.esconde("buscaTiposAnexos");
        this.notificacaoService.erro(erro);
      },
      () => {
        this.carregandoService.esconde("buscaTiposAnexos");
      }
    );
  }

  editarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    anexo.editando = true;
  }

  excluirAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Essa operação não poderá ser desfeita. Deseja realmente excluir esse anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.aoExcluir.emit(anexo);
      }
    });
  }

  baixarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    if (anexo.uploadedFile) {
      this.utilitarioService.saveBlob(anexo, anexo.uploadedFile.name);
    } else {
      this.carregandoService.mostra("baixarArquivo");

      this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Anexo).subscribe(
        (arq) => {
          this.utilitarioService.saveBlob(arq, anexo.arquivo);
          this.carregandoService.esconde("baixarArquivo");
        },
        (erro) => {
          this.carregandoService.esconde("baixarArquivo");
          this.notificacaoService.erro(erro);
        }
      );
    }
  }

  visualizarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    this.carregandoService.mostra("visualizarArquivo");

    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Anexo).subscribe(
      (arq) => {
        if (this.utilitarioService.ePDF(anexo.arquivo)) {
          this.utilitarioService.openBlobModal(arq, anexo.arquivo);
        } else if (this.utilitarioService.eImagem(anexo.arquivo)) {
          this.utilitarioService.mostrarImagemBlob(arq, anexo.arquivo);
        } else {
          this.utilitarioService.saveBlob(arq, anexo.arquivo);
        }

        this.carregandoService.esconde("visualizarArquivo");
      },
      (erro) => {
        this.carregandoService.esconde("visualizarArquivo");
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    anexo.editando = false;

    this.aoAtualizar.emit(anexo);
  }

  cancelarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    const anexoOriginal = this.anexos.find(x => x.id === idAnexo);

    anexo.descricao = anexoOriginal.descricao;

    if (anexoOriginal.tipoAnexo) {
      anexo.tipoAnexo.id = anexoOriginal.tipoAnexo.id || 0 ;
      anexo.tipoAnexo.nome = anexoOriginal.tipoAnexo.nome || "Classificar";
    } else {
      anexo.tipoAnexo = { id: 0, nome: 'Classificar' }
    }

    anexo.editando = false;
  }

  onFileDropped(event: any) {
    this.salvaListaAnexos(event);
  }

  fileBrowseHandler(event: any) {
    this.salvaListaAnexos(event.target.files);
  }

  salvaListaAnexos(files: Array<File>) {
    const anexos: AnexoModel[] = [];

    for (const item of files) {
      const anexo: AnexoModel = {
        descricao: item.name,
        uploadedFile: item,
      };

      anexos.push(anexo);
    }

    this.aoCriar.emit(anexos);
  }
}
